//#region src/lib/color.ts
var HEX = /^#([0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/i;
var RGB = /^rgba?\(\s*([^)]+)\)$/i;
var MIX_TRANSPARENT = /^color-mix\(\s*in srgb\s*,\s*(.+?)\s+(\d+(?:\.\d+)?)%\s*,\s*transparent\s*\)$/i;
function channel(value, max) {
	const trimmed = value.trim();
	return trimmed.endsWith("%") ? parseFloat(trimmed) / 100 * max : parseFloat(trimmed);
}
/**
* Parses a hex (#rgb, #rgba, #rrggbb, #rrggbbaa) or rgb()/rgba() colour, in comma or
* space syntax, or `color-mix(in srgb, <colour> N%, transparent)` (a tint, which the
* tokens use). Returns undefined for anything else.
*/
function parseColor(input) {
	const value = input.trim();
	const mix = MIX_TRANSPARENT.exec(value);
	if (mix) {
		const base = parseColor(mix[1]);
		return base && {
			...base,
			a: base.a * (Number(mix[2]) / 100)
		};
	}
	const hex = HEX.exec(value)?.[1];
	if (hex) {
		const [r = 0, g = 0, b = 0, a = 255] = (hex.length <= 4 ? [...hex].map((d) => d + d) : hex.match(/../g)).map((d) => parseInt(d, 16));
		return {
			r,
			g,
			b,
			a: a / 255
		};
	}
	const rgb = RGB.exec(value)?.[1];
	if (rgb) {
		const [colour = "", alpha] = rgb.split("/");
		const parts = colour.split(/[\s,]+/).filter(Boolean);
		const commaAlpha = parts.length === 4 ? parts.pop() : void 0;
		const [r, g, b] = parts.map((part) => channel(part, 255));
		if (r === void 0 || g === void 0 || b === void 0) return void 0;
		const a = alpha ?? commaAlpha;
		return {
			r,
			g,
			b,
			a: a === void 0 ? 1 : channel(a, 1)
		};
	}
}
/** Composites a (possibly translucent) colour over an opaque background. */
function composite(top, bottom) {
	const mix = (t, b) => t * top.a + b * (1 - top.a);
	return {
		r: mix(top.r, bottom.r),
		g: mix(top.g, bottom.g),
		b: mix(top.b, bottom.b),
		a: 1
	};
}
/** WCAG 2 relative luminance of an opaque colour. */
function relativeLuminance({ r, g, b }) {
	const linear = (c) => {
		const s = c / 255;
		return s <= .04045 ? s / 12.92 : ((s + .055) / 1.055) ** 2.4;
	};
	return .2126 * linear(r) + .7152 * linear(g) + .0722 * linear(b);
}
/**
* WCAG 2 contrast ratio between a foreground and a background. A translucent
* foreground is composited over the background first; the background must be opaque.
*/
function contrastRatio(foreground, background) {
	const [light, dark] = [relativeLuminance(foreground.a < 1 ? composite(foreground, background) : foreground), relativeLuminance(background)].sort((x, y) => y - x);
	return (light + .05) / (dark + .05);
}
//#endregion
export { composite, contrastRatio, parseColor, relativeLuminance };

//# sourceMappingURL=color.js.map